import { Box, Button, Drawer, IconButton } from '@mui/material';
import CloseIcon from '@/assets/CloseIcon.svg';
import FlexBox from '@/atomic-components/FlexBox';
import { useCart } from '@/hooks/useCart';
import { getStyle } from '@/utils/theme/fonts';
import Link from 'next/link';
import { getColor } from '@/utils/theme/colors';
import RightArrowIcon from '@/assets/RightArrowIcon';

type MinimumOrderValueDrawer = {
	open: boolean;
	onClose: () => void;
	cta:any
	title?:string
	description:string
	titleIcon?:any
	subtitle?:any
	onProceed?:any
	showProceedCta?:any
};

export const MinimumOrderValueDrawer = (props: MinimumOrderValueDrawer) => {
	// const { cart } = useCart();

	// const failureCtx = props?.failurectx;

	return (
		<Drawer anchor='right' open={props.open} onClose={props.onClose}>
			<Box width='400px' p='80px 40px'>
				<FlexBox justifyContent='space-between' alignItems='center'>
					{props?.titleIcon ? <Box
						sx={{
							div: {
								...getStyle('H11_Medium'),
							},
						}}
						
					>{props?.titleIcon}</Box>:
					<Box
					sx={{
						div: {
							...getStyle('H11_Medium'),
						},
					}}
					dangerouslySetInnerHTML={{
						__html:
							props?.title as string,
					}}
				></Box>}
					<IconButton onClick={props.onClose}>
						<CloseIcon />
					</IconButton>
				</FlexBox>
				{props?.subtitle && <Box sx={{pt:'32px',pb:'20px',...getStyle('H11_Medium')}} dangerouslySetInnerHTML={{
						__html:
							props?.subtitle as string,
					}}>
					
				</Box>}
				<Link href={props?.cta as string}>
					<div
						style={getStyle('P_Regular')}
						dangerouslySetInnerHTML={{
							__html: props?.description as string,
						}}
					></div>
				</Link>
				{props?.showProceedCta && <Button sx={{...getStyle('P-SemiBold'),width:'100%',background:getColor('Minty +1'),padding:'10px 0',color:'white', borderRadius:'30px',mt:'24px',':hover':{
					background:getColor('Minty +1')
				}}} onClick={props?.onProceed}>Proceed <RightArrowIcon/></Button>}
			</Box>

		</Drawer>
	);
};
